// React
import Content from "Types/Content";
import React from "react";

// Routing
import { RouteProps } from "react-router";
import { BrowserRouter, Switch, Route } from "react-router-dom";

// Views
import { FirstForm } from "./pages/FirstForm";
import { SecondForm } from "./pages/SecondForm";
import { ThirdForm } from "./pages/ThirdForm";
import { FourForm } from "./pages/FourForm";

// Contexts
import { ClientContextProvider } from "./context/ClientContext";
import { FormDataProvider } from "./context/FormContext";

const FormularioContexto: React.FC<RouteProps> = () => {
  return (
    <ClientContextProvider>
      <FormDataProvider>
        <BrowserRouter>
          <Switch>
            <Route
              path='/example/forms-challenge'
              exact
              component={FirstForm}
            />
            <Route
              path='/example/forms-challenge/second'
              component={SecondForm}
            />
            <Route
              path='/example/forms-challenge/third'
              component={ThirdForm}
            />
            <Route path='/example/forms-challenge/four' component={FourForm} />
          </Switch>
        </BrowserRouter>
      </FormDataProvider>
    </ClientContextProvider>
  );
};

export default new Content({
  Component: FormularioContexto,
  title: "Formularios Contexto",
  route: "forms-challenge",
  tags: ["frontend", "valentin", "galfre", "context", "form", "bootstrap"]
});
